import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

export default function NotFound() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--primary)' }}>
      <Header />
      <div style={{ textAlign: 'center', padding: '100px 24px' }}>
        <div style={{ fontSize: '80px', fontWeight: 900, color: '#e94560', marginBottom: '16px' }}>404</div>
        <p style={{ color: '#f0f0f5', fontSize: '20px', marginBottom: '8px' }}>الصفحة غير موجودة</p>
        <p style={{ color: '#9ca3af', fontSize: '16px', marginBottom: '8px' }}>صفحه پیدا نشد</p>
        <p style={{ color: '#9ca3af', fontSize: '16px', marginBottom: '36px' }}>Page not found</p>
        <Link to="/" style={{
          display: 'inline-block',
          padding: '14px 36px',
          background: 'linear-gradient(135deg, #e94560, #c0392b)',
          color: 'white',
          borderRadius: '12px',
          textDecoration: 'none',
          fontWeight: 700,
          fontSize: '16px',
        }}>
          ← Home
        </Link>
      </div>
    </div>
  );
}
